import React, { useState } from 'react';
import { db } from '../firebase'; // Firebase config
import { collection, addDoc } from 'firebase/firestore';

const HalalMarketDataEntryPage = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [marketType, setMarketType] = useState('');
  const [price, setPrice] = useState('');
  const [picture, setPicture] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('Adding market to the database...');

    try {
      await addDoc(collection(db, 'halalMarkets'), {
        name,
        description,
        country,
        city,
        marketType,
        price: parseFloat(price),
        picture,
      });
      setStatus('Market added successfully!');
      setLoading(false);
      // Clear the form
      setName('');
      setDescription('');
      setCountry('');
      setCity('');
      setMarketType('');
      setPrice('');
      setPicture('');
    } catch (error) {
      setStatus('Error adding market: ' + error.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-lg mx-auto">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Add New Halal Market</h2>
        
        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">Market Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Description */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
              rows="4"
            />
          </div>

          {/* Country */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">Country</label>
            <input
              type="text"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* City */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">City</label>
            <input
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Market Type */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">Market Type</label>
            <input
              type="text"
              value={marketType}
              onChange={(e) => setMarketType(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Price Range */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">Price Range</label>
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
              min="0"
            />
          </div>

          {/* Picture URL */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600">Picture URL</label>
            <input
              type="text"
              value={picture}
              onChange={(e) => setPicture(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
            />
          </div>

          {/* Status Message */}
          {status && <p className="text-blue-500 text-sm mb-4">{status}</p>}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
            disabled={loading}
          >
            {loading ? 'Adding Market...' : 'Add Market'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default HalalMarketDataEntryPage;
